// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2b6YX","amount":"Amount_amount__1890h","tip":"Amount_tip__3zeDg","tipHeader":"Amount_tipHeader__1yZeZ","tipsWrap":"Amount_tipsWrap__WVSvU"};